import React from 'react';

import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import {ListItemViewModel} from "../../../../infrastructure/models/list-item.view-model";
import styles from "../styles/secondary-tabs.module.scss";
import classNames from "classnames";

export class SecondaryTabProps extends BaseProps {
  tab: ListItemViewModel;
  active: Boolean;
  onClick: Function;
}

export const SecondaryTab = (props: SecondaryTabProps) => {
  const tabContainer = {
    className: classNames(styles.tab_button_container, styles.tab_container, {[styles.active]: props.active}),
    onClick: (e) => !props.active && props.onClick(e, props.tab)
  }

  return (
    <div {...tabContainer}>
      {props.tab.name}
    </div>
  )
};
